var _style, _g, _g2, _g3, _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtBurgerGroWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353.3 183.7",
    style: {
      enableBackground: "new 0 0 353.3 183.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:inline;fill:#262324;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_white_x5F_alier",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.1,171.8l-23.2-11.6V75.4L167.4,64v-8h-28.5V27.9h-14.5l-9.2,34.3v56.5l0,0c-0.3,15.3-5.6,28.1-15.5,37.2 c-9.8,9-23.1,13.4-36.7,12.3c-22.1-2.2-37.5-19.5-37.5-42.1c0-12.7,6.8-25.4,17.7-33c11.6-8.1,26.1-9.6,40.9-4.4l7.5-9.5L36.7,27.9 h49.9L96,61h8.5V6.4H12.4v22l52.1,43.5L61,71.4c-0.6-0.1-1-0.1-1-0.1c-2.7-0.3-5.3-0.5-7.8-0.5c-16,0-27,6.6-33.8,12.6 C6.9,93.5,0,108.9,0,124.3c0,15.6,6.2,30,17.5,40.8c11.6,11,27.8,17.2,45.6,17.5c32.9,0.4,49.9-20.5,58.4-38.1l0.4-0.9l11.7,6.3 l-16.3,30.2H162v-8.3L162.1,171.8L162.1,171.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_black_x5F_et",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.7,76.2l28.5-11.4v-9.7h-28.5V55V29h-16.2l-9.4,33.1v55.4l0,0c0,35-26.7,51.8-51.2,49.8 c-21-2.1-36.6-18.5-36.6-41.1c0-24.2,25-48.3,57.9-36.2l0,0l0,0l0,0l0,0l8.4-10.8L41,29h46.7l9.4,33.1h9.5V5.5H13.2V29L63,70.6 c-0.7-0.1-1-0.1-1-0.1c-38-4.9-61.2,25.7-61.2,54c0,32.2,26.1,58.7,64.1,59.2c34.1,0.5,51.2-21.7,59.3-38.7l9.9,5.3L117.5,181h47.3 v-9.8l-23.1-11.5v-83L141.7,76.2L141.7,76.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.9,56.5h-31.8V28.7h-23.4v67.5c0,20.2-4.2,36.3-12.4,47.9c-8.9,12.5-22.1,18.9-39.2,19.1l0,0 c-11.5,0-22.3-4.3-29.6-11.7c-6.9-7-10.5-16.4-10.3-27.1c0.2-13.7,6-25.2,16.3-32.3c11.7-8,27.8-9.3,44.3-3.4l9.2-12l-55.4-48h77.1 V7.5H11.4v22.4l47.9,41l-3.1-0.3c-1.8-0.2-3.5-0.3-5.3-0.3c-12.1,0-23,4.2-31.9,12.2C7.7,92.8,1,108.3,1,124 c0,15.5,5.9,29.9,16.6,40.5c11.1,11,26.6,17.1,43.6,17.2c0.1,0,0.2,0,0.3,0c11.5,0,21.8-2.4,30.6-7.3c7.9-4.3,14.7-10.6,20.2-18.5 l0.3-0.4h3.1v23.6h23.4V76.2H171L170.9,56.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 56.5,
    className: "st3",
    width: 144.5,
    height: 19.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 107.8,
    className: "st3",
    width: 144.5,
    height: 19.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 159,
    className: "st3",
    width: 144.5,
    height: 19.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st4",
    width: 353.3,
    height: 183.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtBurgerGroWhite);
export default __webpack_public_path__ + "static/media/et-burger-gro-white.3a6422ae420d2f7f0306d56b36545cd3.svg";
export { ForwardRef as ReactComponent };